var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneStraight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 310,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.93 93.44l-226.592.228c-4.438.351-4.463.35-9.816 1.141-6.315.533-13.924 5.327-19.86 11.262-5.934 5.935-6.466 17.652-6.466 17.652L4.89 686.096l-.152 11.338c-.152 11.337 8.293 20.316 12.174 23.969 6.785 5.179 15.414 6.409 23.283 6.924l217.844.836h3.5c3.5 0 21.989-1.903 31.728-8.827 9.74-6.924 11.49-25.945 11.49-25.945V123.19l-.304-2.207-.153-1.826-.152-1.446s-1.218-8.446-10.805-16.359c-9.587-7.913-25.414-7.912-25.414-7.912zm-60.795 12.783l70.23.379s6.465-.23 10.216 1.105c6.312 2.536 7.71 5.352 7.793 12.104l-.069 565.309s1.54 12.894-2.474 17.97c-3.66 4.627-9.362 7.317-18.4 7.317h-9.04l-221.885.107s-15.17.646-21.412-3.766c-6.24-4.411-7.426-8.608-7.426-12.375 0-3.766-.107-5.703-.107-5.703l-.107-569.021s.383-7.326 5.271-10.223c5.81-3.443 8.071-2.796 10.008-2.904l1.937-.108 68.028.874s4.566-.38 5.594.38c1.027.761 2.472 1.901 2.625 3.385.152 1.484-.506 7.505 2.972 9.99 2.969 2.122 4.902 2.565 8.744 2.641l3.844.076 16.625-.19 45.197-.228s6.965.527 9.819-2.688c3.017-3.4 2.41-8.023 2.487-10.762.076-2.74 1.66-2.843 2.687-3.223 1.028-.38 6.843-.446 6.843-.446z",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.224 307.05l.12 35.344s.108.969 1.614.969c1.507 0 1.4-1.507 1.4-1.507l.012-34.718s-.13-.891-1.627-.9c-1.355-.007-1.519.811-1.519.811zM2.862 273.976l.12 35.345s.107.968 1.614.968c1.506 0 1.399-1.506 1.399-1.506l.013-34.718s-.13-.892-1.627-.9c-1.355-.008-1.52.811-1.52.811zM3.077 319.601l.12 35.345s.108.968 1.614.968c1.507 0 1.4-1.506 1.4-1.506l.012-34.718s-.13-.892-1.627-.9c-1.355-.008-1.519.811-1.519.811zM3.077 406.332l.12 35.344s.108.969 1.614.969c1.507 0 1.4-1.507 1.4-1.507l.012-34.718s-.13-.891-1.627-.9c-1.355-.007-1.519.812-1.519.812z",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.705,
    cy: 112.332,
    r: 4.304,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4.304,
    cy: 112.332,
    cx: 151.328,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.133 109.349s-3.497.107-3.497 2.636 1.56 3.282 3.551 3.282c3.175 0 12.429.161 12.429.161s3.013-.269 3.013-2.851c0-2.583-.861-3.228-3.336-3.228z",
    fill: "#333",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.613 3.591L55.263 638.478s-32.524 2.805-42.316-11.292c-9.792-14.096-7.963-16.463-7.963-27.977s-.108-14.204-.108-14.204l.091-232.317s-1.788.228-1.788-1.541v-1.769l-.114-32.68s.02-1.085 1.103-1.16c1.085-.077.914.037.914.037l-.038-.323.038-49.344s-2.017.609-1.94-2.092c.075-2.701.075-2.854.075-2.854l-.133-30.835s-.095-1.027.666-1.198c.76-.171 1.332-.114 1.332-.114l.01-8.676s-2.153.78-2.153-1.318v-2.098l-.064-32.458s0-1.104 1.236-1.085c1.237.02 1.047.115 1.047.115L5.12 35.092s-.38-14.609 10.043-22.294c10.425-7.685 18.11-9.207 27.925-9.207 9.816 0 11.033.076 11.033.076z",
    opacity: 0.1,
    fill: "#999",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneStraight);
export default __webpack_public_path__ + "static/media/phone-straight.c7f3410e470b90537d0dd4bfd90b43b3.svg";
export { ForwardRef as ReactComponent };